import { atom } from 'jotai'
// @deepguide-ai/react-image-editor has been removed
type AnyShapeData = any
type InteractionPointData = any

// 编辑器打开/关闭状态
export const isImageEditorOpenAtom = atom<boolean>(false)

export interface ImageEditorData {
  src: string
  initialInteractionPoints?: InteractionPointData[]
  initialAnnotations?: AnyShapeData[]
  stepId?: string
}

// 默认数据
export const defaultImageEditorData: ImageEditorData = {
  src: 'https://storage.versepen.ai/uploads/article/1756780053317-bzd0yv2rnh.png',
  initialInteractionPoints: [
    {
      id: 'interaction-1',
      tool: 'interactionPoint' as const,
      x: 10,
      y: 10,
      type: 'Click' as const,
      label: 'Click me',
      tooltip: 'Click me to open the menu',
      order: 1,
      stepId: '1',
    },
  ],
}

// 使用atom管理imageEditorData
export const imageEditorDataAtom = atom<ImageEditorData>(defaultImageEditorData)

// 获取数据的方法 - 修复为只读atom
export const getImageEditorDataAtom = atom((get) => get(imageEditorDataAtom))

// 保存数据的方法
export const saveImageEditorDataAtom = atom(
  null,
  (_get, set, data: ImageEditorData) => {
    set(imageEditorDataAtom, data)
  }
)

// 更新部分数据的方法
export const updateImageEditorDataAtom = atom(
  null,
  (_get, set, updates: Partial<ImageEditorData>) => {
    set(imageEditorDataAtom, (prev) => ({
      ...prev,
      ...updates,
    }))
  }
)

// 重置数据
export const resetImageEditorDataAtom = atom(null, (_get, set) => {
  set(imageEditorDataAtom, defaultImageEditorData)
})

// 按 stepId 存储已编辑截图的信息，包括 URL 和 viewportCoordinates
export interface EditedScreenshotData {
  url: string
  viewportCoordinates?: {
    topLeft: { x: number; y: number }
    topRight: { x: number; y: number }
    bottomLeft: { x: number; y: number }
    bottomRight: { x: number; y: number }
    center: { x: number; y: number }
    width: number
    height: number
  }
}

export const editedScreenshotMapAtom = atom<Record<string, EditedScreenshotData>>({})
